module.exports = __webpack_public_path__ + "static/media/marketplace.2f414ab1.PNG";